import isNormalMetric from 'types/metricTypeCheckers/isNormalMetric';

export const getFieldView = (
  metric: Metrics.Metric | undefined,
  baseViews: FleetOps.BaseView[],
): FleetOps.BaseViewField | undefined => {
  if (isNormalMetric(metric)) {
    const bv = baseViews.find((bv) => bv.type === metric.dataType);
    if (!bv) {
      return undefined;
    }

    const bf = bv.fields[metric.field];
    if (!bf) {
      return undefined;
    }

    return bf;
  }

  return undefined;
};

export default getFieldView;
